module.exports = __webpack_public_path__ + "static/media/MagicBall.53a7025b.svg";